import React, { useEffect, useRef } from 'react'

const Limit = React.memo(({ handleFixed }) => {
  let limit = useRef(null)

  const onScroll = () => {
    if (limit !== null) {
      handleFixed(window.pageYOffset < limit.offsetTop - window.innerHeight)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  })

  return <div ref={ref => (limit = ref)} />
})

export default Limit
